<template>
  <!-- 添加报名 -->
  <el-dialog
    class="dialog-add-activity"
    title="添加报名"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    width="650px"
  >
    <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <!-- <el-col :span="24">
          <el-form-item label="报名时间 :" prop="mydate">
            <el-date-picker
              :disabled="pageType === 'detail'"
              v-model="form.mydate"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>-->

        <el-col :span="24">
          <el-form-item label="姓名 :" prop="realName">
            <el-input v-model="form.realName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="家长 :" prop="parentName">
            <el-input v-model="form.parentName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="电话 :" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="footer mt-30">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate } from '@/utils/util'
export default {
  data() {
    let validatePhoneNo = (rule, value, callback) => {
      if (!validate(value, 'phone')) {
        callback(new Error('手机号不存在'))
      } else {
        callback()
      }
    }
    // let validatePass = (rule, value, callback) => {
    //   if (!validate(value, 'password')) {
    //     callback(new Error('6-20位数字、字母、特殊字符至少包含两种'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loadingSave: false,
      pageType: '', // 页面类型 add 新增 edit 编辑 detail 查看 check 考核结果
      detailId: '', // 详情id
      titleStr: '添加志愿者',
      dialogVisible: false,
      form: {
        // proName: '',
        // typeId: '',
        // price: ''
      },
      // form1: {},
      rules: {
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        parentName: [{ required: true, message: '请输入家长', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhoneNo, trigger: 'blur' }
        ]
        // proName: [{ required: true, message: '必填', trigger: 'blur' }]
        // qudao: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      // rules1: {},
      sexList: [{ name: '男', value: '1' }, { name: '女', value: '0' }],
      remoteFileList: [],
      staffTypeArr: [], // 人员类型；列表
      departmentArr: [], // 部门列表
      jobTypeArr: [], // 职位列表
      userArr: [] // 人员列表
    }
  },
  methods: {
    init(type, detailId) {
      this.pageType = type // add 新增 edit 编辑 detail 查看 check 考核结果
      this.detailId = detailId || ''
      this.form = {}
      this.remoteFileList = []
      this.setTitle()

      this.$nextTick(() => {
        // this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
      })

      this.dialogVisible = true
      // if (this.detailId) {
      //   this.getDetail()
      // }
      this.getSelect()
    },
    setTitle() {
      switch (this.pageType) {
        case 'add':
          this.titleStr = '添加志愿者'
          break
        case 'check':
          this.titleStr = '志愿者审核'
          break
        case 'interview':
          this.titleStr = '志愿者面试结果'
          break
        default:
          break
      }
    },
    // 查询下拉框
    getSelect() {
      this.$http.post('/job/employeeDict').then(res => {
        if (res.success) {
          let data = res.result
          this.staffTypeArr = data.employeeType
          this.departmentArr = data.department
          this.jobTypeArr = data.jobType
          this.userArr = data.user

          if (this.detailId) {
            this.getDetail()
          }
        }
      })
    },
    // 详情
    getDetail() {
      this.form.proName = 'aaaa'
      this.$http
        .get('/user/listEmployee', {
          userId: this.detailId
        })
        .then(res => {
          if (res.success) {
            let data = res.result[0]
            this.form = data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 保存
    fromSubmit(form) {
      console.log(this.form)
      if (this.pageType === 'check') {
        this.sendCheck()
        return
      } else if (this.pageType === 'interview') {
        this.sendInterview()
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('bsActivity/adminActivitySign', {
              ...this.form,
              activityId: this.$route.query.id
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('添加报名成功')
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    sendCheck() {
      console.log(this.form, this.detailId)
    },
    sendInterview() {
      console.log(this.form)
    },
    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-add-staff {
  /deep/ .el-form-item__error {
    left: 0;
  }
}
</style>